import React from "react";
import styles from "./Tooltip.module.css";

const Tooltip = ({ text, children }) => {
  return (
    <span className={styles.wrapper} tabIndex={-1}>
      {children}
      <span className={styles.tooltip} role="tooltip">{text}</span>
    </span>
  );
};

export default Tooltip;
